export default __webpack_public_path__ + "static/media/parent.8ca7f42d.png";